/*
 * Refresh collection page (sections/rd-main-collection.liquid):
 * - filters / sort apply instantly via the Section Rendering API, URL kept in sync
 * - price buckets map to filter.v.price.gte / .lte
 * - "Load more finds" appends the next page
 * - phones: filter drawer
 */
(() => {
  const root = document.querySelector('.rd-collection[data-section-id]');
  if (!root) return;
  const sectionId = root.dataset.sectionId;
  let controller;

  const swap = (doc) => {
    ['filters', 'results'].forEach((key) => {
      const next = doc.querySelector(`[data-rd-swap="${key}"]`);
      const current = root.querySelector(`[data-rd-swap="${key}"]`);
      if (next && current) current.replaceWith(next);
    });
  };

  const render = async (url, { push = true } = {}) => {
    controller?.abort();
    controller = new AbortController();
    const results = root.querySelector('[data-rd-swap="results"]');
    results?.setAttribute('aria-busy', 'true');
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);
    try {
      const response = await fetch(fetchUrl, { signal: controller.signal });
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      swap(doc);
      if (push) {
        const clean = new URL(url, window.location.origin);
        clean.searchParams.delete('section_id');
        history.replaceState({}, '', clean.pathname + clean.search);
      }
    } catch (error) {
      if (error.name !== 'AbortError') window.location.href = url;
    }
  };

  const formUrl = () => {
    const form = root.querySelector('[data-rd-filter-form]');
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (value !== '') params.append(key, value);
    });
    const sort = root.querySelector('[data-rd-sort]');
    if (sort) params.set('sort_by', sort.value);
    return `${root.dataset.url}?${params.toString()}`;
  };

  let timer;
  root.addEventListener('change', (event) => {
    const bucket = event.target.closest('[data-rd-price-bucket]');
    if (bucket) {
      // price buckets behave like radio buttons that can be unticked
      root.querySelectorAll('[data-rd-price-bucket]').forEach((b) => b !== bucket && (b.checked = false));
      root.querySelector('[data-rd-price-min]').value = bucket.checked && bucket.dataset.min !== '0' ? bucket.dataset.min : '';
      root.querySelector('[data-rd-price-max]').value = bucket.checked ? bucket.dataset.max : '';
    }
    if (!event.target.closest('[data-rd-filter-form]') && !event.target.matches('[data-rd-sort]')) return;
    clearTimeout(timer);
    timer = setTimeout(() => render(formUrl()), 250);
  });

  root.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-rd-filter-form]')) return;
    event.preventDefault();
    render(formUrl());
  });

  root.addEventListener('click', async (event) => {
    const link = event.target.closest('a[data-rd-link]');
    if (link) {
      event.preventDefault();
      render(link.href);
      return;
    }

    const more = event.target.closest('a[data-rd-loadmore]');
    if (more) {
      event.preventDefault();
      more.setAttribute('aria-busy', 'true');
      more.textContent = 'Loading…';
      const url = new URL(more.href, window.location.origin);
      url.searchParams.set('section_id', sectionId);
      try {
        const doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html');
        const grid = root.querySelector('[data-rd-grid]');
        doc.querySelectorAll('[data-rd-grid] > li').forEach((li) => grid.append(li));
        const nextFooter = doc.querySelector('.rd-loadmore');
        root.querySelector('.rd-loadmore').replaceWith(nextFooter);
        const count = root.querySelector('[data-rd-count]');
        const newCount = doc.querySelector('[data-rd-count]');
        if (count && newCount) count.textContent = newCount.textContent;
        grid.querySelectorAll('li')[grid.querySelectorAll('li').length - doc.querySelectorAll('[data-rd-grid] > li').length]?.querySelector('a')?.focus({ preventScroll: true });
      } catch (error) {
        window.location.href = more.href;
      }
      return;
    }

    if (event.target.closest('[data-rd-filters-open]')) openDrawer();
    if (event.target.closest('[data-rd-filters-close]')) closeDrawer();
  });

  // Phones: filter drawer
  const drawer = () => root.querySelector('[data-rd-filters]');
  const openDrawer = () => {
    drawer().classList.add('is-open');
    document.body.classList.add('rd-no-scroll');
    root.querySelector('[data-rd-filters-open]')?.setAttribute('aria-expanded', 'true');
    drawer().querySelector('input, button, a')?.focus();
  };
  const closeDrawer = () => {
    drawer().classList.remove('is-open');
    document.body.classList.remove('rd-no-scroll');
    const toggle = root.querySelector('[data-rd-filters-open]');
    toggle?.setAttribute('aria-expanded', 'false');
    toggle?.focus();
  };
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer()?.classList.contains('is-open')) closeDrawer();
  });
})();
